import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Activities_Left from './Activities_Left'

import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'
import { Link } from 'react-router-dom';


function Sports() {






   





    return (

        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Club Committee Members" />



            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <Row>
                            <div className="c-heading">
                                <h4>Club Committee Members</h4> <br />
                            </div>

                            <Col md={3} className='c-left custom-padding-color mb-4'>
                                <Activities_Left activeIndex={0} />
                            </Col>

                            <Col md={9} className='c-right'>
               
                                <h4 className='c-headline mt-5 mb-3'>Technical Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://mech.iittp.ac.in/dr-thiyagarajan-r" target="_blank"> Dr. Thiyagrajan R </Link></p>
                                <p>Student Secretary: Chirag Kotian</p>
                                <p>Email : <Link className='c-link' to="mailto:technical_sec@iittp.ac.in"> technical_sec@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Cultural Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://mech.iittp.ac.in/dr-ajay-kumar" target="_blank"> Dr. Ajay Kumar</Link></p>
                                <p>Student Secretary: Apoorv Shukla</p>
                                <p>Email : <Link className='c-link' to="mailto:cultural_sec@iittp.ac.in"> cultural_sec@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Sports Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://mech.iittp.ac.in/dr-thiyagarajan-r" target="_blank"> Dr. S. Udaykumar </Link></p>
                                <p>Physical Education Officer: Dr. Iyappan.I</p>
                                <p>Physical Training Instructor: Mr. Sreedhar Reddy T</p>
                                <p>Student Secretary: Pranavesh Reddy</p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> sports@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Literary Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://hss.iittp.ac.in/dr-a-raghuramaraju" target="_blank"> Dr. Raghuram Raju </Link></p>
                                <p>Student Secretary: Akshitha</p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> literary_sec@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Academics Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://mast.iittp.ac.in/People-Faculty.html" target="_blank"> Dr. Ishapathik Das </Link></p>
                                <p>Student Secretary: Rohit Krishna</p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> academics@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>NSS Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://cy.iittp.ac.in/index.php?option=com_content&view=article&layout=edit&id=101" target="_blank"> Dr. Debasish Mondal </Link></p>
                                <p>Student Secretary:  </p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> nss@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Career Development and Guidance Center </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://mech.iittp.ac.in/dr-subbareddy-daggumati" target="_blank"> Dr. Subbareddy Daggumati  </Link></p>
                                <p>Student Secretary: Divyanshu Dwivedi</p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> cdc@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Research Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://chemical.iittp.ac.in/dr-anki-reddy-katha" target="_blank"> Dr. Katha Anki Reddy </Link></p>
                                <p>Student Secretary: Milind </p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> research@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>HoME Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://cee.iittp.ac.in/dr-prasanna-venkatesh-sampath" target="_blank"> Dr. Prasanna Sampath </Link></p>
                                <p>Student Secretary: Subrahmanya Raghuram </p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in">     home@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Guidance and Counselling Unit (GCU) Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://mech.iittp.ac.in/dr-sriram-sundar" target="_blank"> Dr. Sriram Sundar </Link></p>
                                <p>Student Secretary: Aadya Agarwala</p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> gcu@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>Nisarga Committee </h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://cee.iittp.ac.in/dr-prasanna-venkatesh-sampath" target="_blank"> Dr. Prasanna Sampath </Link></p>
                                <p>Student Secretary: </p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> nisarga@iittp.ac.in</Link></p>
                                     
                   

                                
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Sports;
